import React from 'react';
// Assuming AnimateOnScroll works with inline styles or is not strictly needed for layout
import AnimateOnScroll from '../../Components/AnimateOnScroll'; // Make sure path is correct

// Import the style definitions (adjust path as necessary)
import { colors, typography, layout, commonStyles } from '../styles/minimalStyles';

// Define the inline styles object
const styles = {
  headerContainer: {
    ...commonStyles.container, // Spread common container styles (maxWidth, margin, padding, fontFamily, color)
    borderBottom: `1px solid ${colors.border}`,
    paddingTop: '20px',
    paddingBottom: '30px',
    marginBottom: layout.sectionSpacing,
    textAlign: 'left', // As per previous example
    // Add any other styles previously in NewsHeader.module.css .headerContainer
  },
  mainTitle: {
    fontSize: typography.largeTitleSize, // e.g., '2.5rem'
    fontWeight: typography.normalWeight, // e.g., 'normal'
    margin: '0 0 10px 0', // Margin bottom only
    fontFamily: typography.fontFamily, // Ensure consistent font
    color: colors.primaryText, // e.g., '#333'
    // Add any other styles previously in NewsHeader.module.css .mainTitle
  },
  description: {
    fontSize: '1.1rem', // Example size
    fontWeight: typography.normalWeight,
    color: colors.secondaryText, // e.g., '#6b7280'
    margin: 0, // Reset margin
    fontFamily: typography.fontFamily,
    maxWidth: '800px', // Limit width for readability
    lineHeight: 1.6, // Improve readability
    // Add any other styles previously in NewsHeader.module.css .description
  },
};


const NewsHeader = ({ title, description }) => {
  return (
    <AnimateOnScroll>
      {/* Apply the headerContainer style */}
      <div style={styles.headerContainer}>
        <div>
          {/* Apply the mainTitle style */}
          <h1 style={styles.mainTitle}>{title}</h1>
          {/* Apply the description style if description exists */}
          {description && <p style={styles.description}>{description}</p>}
        </div>
        {/* Optional: Add logos like in AboutHeader if needed */}
      </div>
    </AnimateOnScroll>
  );
};

export default NewsHeader;